import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DeleteDesignationRes;
export const DeleteDesignationTodo = createAsyncThunk('DeleteDesignation', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `superadmin/designation/${id}`,
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DeleteDesignationRes = res.data
        
    } catch (error) {
        return DeleteDesignationRes = error.response.data
    }
})
